import { syncEditorData as publicSyncEditorData } from './multilingual-genericconverter-v1-entity-mapper-entity-mapper.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const syncEditorData: MaybeContext<
  BuildRESTFunction<typeof publicSyncEditorData> & typeof publicSyncEditorData
> = /*#__PURE__*/ createRESTModule(publicSyncEditorData);

export {
  FieldType,
  WebhookIdentityType,
} from './multilingual-genericconverter-v1-entity-mapper-entity-mapper.universal.js';
export {
  Mapper,
  MapperField,
  SequencePath,
  Empty,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  CreateOrUpdateNileMapperRequest,
  CreateOrUpdateNileMapperResponse,
  GetEntityMapperRequest,
  GetEntityMapperResponse,
  ListEntityMapperRequest,
  ListEntityMapperResponse,
  DeleteEntityMapperRequest,
  DeleteEntityMapperResponse,
  GetSubscribedTopicsRequest,
  GetSubscribedTopicsResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  HtmlNewRevisionSavedMessage,
  RevisionInfo,
  Page,
  ChangedPages,
  SyncEditorDataRequest,
  SyncFilter,
  SyncEditorDataResponse,
  PublishSiteTranslationsRequest,
  PublishSiteTranslationsResponse,
  CreateOrUpdateEditorMapperRequest,
  CreateOrUpdateEditorMapperResponse,
  GetMapperRequest,
  GetMapperResponse,
  DeleteMapperRequest,
  DeleteMapperResponse,
  ListMappersRequest,
  ListMappersResponse,
  SyncEditorDataOptions,
} from './multilingual-genericconverter-v1-entity-mapper-entity-mapper.universal.js';
export {
  FieldTypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './multilingual-genericconverter-v1-entity-mapper-entity-mapper.universal.js';
